<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="strategia-view" fluid pt-0>
    <v-app-bar app color="black" dark fixed>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $t('vastuualue.select_vastuualue') }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-row>
                <template v-for="vastuualue in filteredVastuualueet">
                  <vastuualue-box :key="vastuualue.id" :vastuualue="vastuualue"/>
                </template>
                <template v-if="vastuualueet.length === 0">
                  <no-content-view :reload-button="false" :title="$t('vastuualue.ei_vastuualueita')"></no-content-view>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';
import VastuualueBox from "@/components/Vastuualue/VastuualueBox";
import NoContentView from "@/components/NoContentView.vue";

export default {
  name: 'StrategiaView',
  components: {NoContentView, VastuualueBox},
  data() {
    return {
      loading: true,
      vastuualueet: [],
      users: [],
      saving: false,
    };
  },
  computed: {
    filteredVastuualueet() {
      return this.vastuualueet.filter(v => v.aktiivinen);
    }
  },
  methods: {
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueetFull();
      this.vastuualueet = vastuualueet;
    },
    async getUsers() {
      const users = await api.getUsers();
      this.users = users;
    },
  },
  async mounted() {
    await Promise.all([this.getVastuualueet(), this.getUsers()])

    this.loading = false;


    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
